<script setup lang="ts">
  export type ContentArrowsProps = {
    disabled?: boolean
    onClick: () => void
    direction: 'left' | 'right'
    hidden: boolean
  }

  const props = defineProps<ContentArrowsProps>()

  const arrowIcon = computed(() => {
    return props.direction === 'left'
      ? 'i-heroicons-arrow-left-16-solid'
      : 'i-heroicons-arrow-right-16-solid'
  })
</script>

<template>
  <button
    v-show="!disabled && !hidden"
    :aria-label="`${direction} Arrow`"
    class="absolute flex items-center justify-center rounded-4px bg-action-neutral-onDefault-default hover:bg-action-neutral-onDefault-hover px-1 py-4 shadow-article-card"
    :class="{
      'right-1': direction === 'right',
      'left-1': direction === 'left',
    }"
    :disabled="disabled"
    @click="onClick"
  >
    <UIcon :name="arrowIcon" class="text-content-primary" />
  </button>
</template>
